export const Routes = {
	ROOT: '/',
	DASHBOARD: '/dashboard',
	DISCUSSION_VIEW: '/dashboard/discussion',
	ADMIN_USERS: '/admin/users',
	SUPER_ADMIN_USERS: '/super-admin/users',
	ADMIN_DISCUSSIONS: '/admin/discussions',
	ADMIN_DISCUSSION_RESULTS: '/admin/discussions/results',
}
